import React, { useState } from 'react';
import { Select, Col } from 'antd';
import { useDispatch,useSelector } from 'react-redux';
import { selectedFilterBy } from '../../store/actions/leads';



const { Option } = Select;

const FilterDropdown = ({ leadsData,onFilterChange }) => {
  // Filter state
  const selectedFilter = useSelector(state => state.leads.selectedFilterByVal);
  
//   const [selectedFilter, setSelectedFilter] = useState('all');
  const dispatch = useDispatch();

  // Filter options
  const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'mtd', label: 'MTD (Month-to-Date)' },
    { value: 't60', label: 'Last 60 days' }
  ];

  // Handle filter change
  const handleFilterChange = (value) => {
    // setSelectedFilter(value);
    dispatch(selectedFilterBy(value));
    console.log('Selected filter:', value);
    if (onFilterChange) {
      onFilterChange(value); // send value to parent
    }
  };

  return (
    <Col xs={12} sm={12} md={12} lg={4} xl={4}>
        <div className="hierarchy">
          <p style={{ marginBottom: '5px' }}>Filter By</p>
          <Select
            className="filter-dropdown"
            value={selectedFilter}
            onChange={handleFilterChange}
            style={{ width: '100%' }}
            placeholder="Select Filter"
          >
            {filterOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>
    </Col>
  );
};

export default FilterDropdown;
